import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";

import HrNotifications from "../../components/hotelRepresentative/HrNotifications";
import HrCertification from "../../components/hotelRepresentative/HrCertification";

const HrDashboard = (props) => {
  
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
  };
  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    "Pending": "status-pill inline-block bg-pink-50 text-pink-700",
    "Completed": "status-pill inline-block bg-gray-200 text-gray-700",
  };
  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return 'Pending';
    if (code >= 2 && code <= 6) return 'In-Process';
    if (code === 7 || code === 8) return 'Completed';

    return 'Unknown';
  };
  const hotelDetailsFromAttrs = (attrs) => {
    return attrs.split('#');
  }

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setStatus(res.data.statuses);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);

  const [activePhotoshoot, setActivePhotoshoot] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`photoshoot/listing?sortBy=created_at&sortDir=desc&limit=1`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setActivePhotoshoot(res.data.data);
            console.log(res.data.data[0]);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);

  const [brandDetails, setBrandDetails] = useState([]);
  /* Getting Hotel Details */
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`hr/brandDetail`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setBrandDetails(res.data.brand);
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);

  return (
    <>
      <div className="container mx-auto px-8 py-8">
        <div className="h1-wrapper">
            <h1 className="text-3xl font-bold text-gray-800">Hotel Photography Lead</h1>
                {true && <div className="certification-icon-header valid" title="Certification Status">
                    <i className="fas fa-certificate"></i>
                    <div className="certification-tooltip">
                        <div><strong>Status:</strong> Active & Valid</div>
                        <div><strong>Expires:</strong> 30-Jun-2026</div>
                    </div>
                </div>}
                {!true && <div className="certification-icon-header invalid" title="Certification Status">
                    <i className="fas fa-exclamation-triangle"></i>
                    <div className="certification-tooltip">
                        <div><strong>Status:</strong> Expired</div>
                        <div><strong>Expires:</strong> 30-Jun-2023</div>
                    </div>
                </div>}
        </div>

        {/* <!-- Notifications Section --> */}
        {/* <HrNotifications /> */}
        {/* <!-- Certification Status --> */}
        {/* <HrCertification /> */}

        {/* <!-- Hotel Details Section --> */}
        <div className="dashboard-section">
            <div className="section-title flex justify-between items-center">
                <div>
                    <i className="fas fa-building"></i>
                    Hotel Details
                </div>
                {/* <a href="hotel-representative-first-login" className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                    <i className="fas fa-exchange-alt"></i>
                    <span>Switch Brand</span>
                </a> */}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="brand-card p-6">
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Brand</p>
                    <p className="text-xl font-bold text-gray-800">{brandDetails.brand}</p>
                </div>
                <div className="brand-card p-6">
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel</p>
                    <p className="text-xl font-bold text-gray-800">{brandDetails.hotel}</p>
                </div>
                <div className="brand-card p-6">
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Marsha Code</p>
                    <p className="text-xl font-bold text-gray-800 tracking-widest">{brandDetails.marsha}</p>
                </div>
            </div>
        </div>

        {/* <!-- Photoshoot Request Creation Section --> */}
        {activePhotoshoot.length == 0 && (
            <>
            <div className="dashboard-section">
                <div className="section-title">
                    <i className="fas fa-camera-retro"></i>
                    Photoshoot Request Details
                </div>
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                            <p className="text-lg font-bold text-gray-800">{brandDetails.hotel}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Create Photoshoot Request</p>
                            <p className="text-lg font-bold text-gray-800">
                                <a href="hotel-representative-photoshoot-requirement-form" className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                                    <i className="fa-regular fa-camera"></i>
                                    <span>Photoshoot Request</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )}
                

        {/* <!-- Photoshoot Request Section --> */}
        {activePhotoshoot.length > 0 && (
            <>
            <div className="dashboard-section">
                <div className="section-title">
                    <i className="fas fa-camera-retro"></i>
                    Photoshoot Request Details
                </div>
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                            <p className="text-lg font-bold text-gray-800">{brandDetails.hotel}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Date Range</p>
                            <p className="text-lg font-bold text-gray-800">
                                <i className="fas fa-calendar-alt text-gray-600"></i>
                                {formatDate(activePhotoshoot[0].date_from)} to {formatDate(activePhotoshoot[0].date_to)}
                            </p>
                        </div>
                    </div>
                    <div className="mt-6 pt-6 border-t border-gray-300 flex items-center justify-between">
                        <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide">Status {status[activePhotoshoot[0].status]}</p>
                        <div className={statusClasses[getStatusLabel(activePhotoshoot[0].status)]}><i className="fa-solid fa-circle"></i></div>
                    </div>

                    <div className="mt-4">
                        <a href={`hotel-representative-photoshoot-details/${activePhotoshoot[0].id}`} className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                            <i className="fas fa-file-alt"></i>
                            <span>Recce Deck</span>
                        </a>
                    </div>
                </div>
            </div>
            </>
        )}


    </div>
    </>
  );
};

export default HrDashboard;
